var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexSearchPageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2268_36036)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_2268_36036)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 65.002,
    r: 411,
    fill: "#C4AAEB",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_2268_36036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1809.44 703.002C1809.44 931.648 1294.59 1230 1065.94 1230C390.444 770.002 1260.44 948.648 1260.44 720.002C1260.44 491.356 1166.8 289.002 1395.44 289.002C1624.09 289.002 1809.44 474.356 1809.44 703.002Z",
    fill: "#C4AAEB",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_f_2268_36036)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.5,
    cy: 1205.5,
    rx: 283.5,
    ry: 287.5,
    fill: "#00D0DB",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2268_36036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769.441 429.778C667.898 312.702 866.592 -62.8178 421.431 -398.619C538.202 -499.897 1090.76 -54.0582 1192.3 63.0176C1293.85 180.093 1281.5 357.104 1164.73 458.382C1047.96 559.66 870.984 546.853 769.441 429.778Z",
    fill: "#3BADFF",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2268_36036",
    x: -395,
    y: -645.998,
    width: 1422,
    height: 1422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2268_36036"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2268_36036",
    x: 509,
    y: -10.998,
    width: 1600.44,
    height: 1541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2268_36036"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2268_36036",
    x: -209,
    y: 618.002,
    width: 1167,
    height: 1175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2268_36036"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2268_36036",
    x: 121.431,
    y: -713.466,
    width: 1439.64,
    height: 1540.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2268_36036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2268_36036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexSearchPageBg);
export default __webpack_public_path__ + "static/media/index-search-page-bg.7a2c308c6bdacfe6f971da104a1974bb.svg";
export { ForwardRef as ReactComponent };